const chat = {
	'chat.input.placeholder1': 'Ne bilmek istiyorsunuz? ',
	'chat.input.placeholder2': 'Son cevabı bekliyorum',
	'chat.submit.btn': 'Gönder',
	'chat.submit.on.address': 'Hesap etkinleştirilmedi, sohbet edilemiyor',
	'chat.wallet.btn.title': 'Cüzdan bağlı değil, sohbet edilemiyor',
	'chat.data.params.msg1': 'Sistem hatası',
	'chat.data.params.msg2': 'Kullanıcı etkinleştirilmedi',
	'chat.data.params.msg3': 'Günde yalnızca 10 kez erişebilirsiniz',
	'chat.data.params.msg1001': 'Geçersiz json',
	'chat.data.params.msg.other': 'İstek başarısız oldu, lütfen tekrar deneyin',
}

export default chat
